"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _reactRouterDom = require("react-router-dom");

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Badge = _interopRequireDefault(require("../Badge/Badge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // The usage of React.forwardRef will no longer be required for react-router-dom v6.


var NavLinkWithRef = _react["default"].forwardRef(function (props, ref) {
  return _react["default"].createElement(_reactRouterDom.NavLink, _extends({
    innerRef: ref
  }, props));
});

var NavItem = function NavItem(_ref) {
  var classes = _ref.classes,
      icon = _ref.icon,
      label = _ref.label,
      route = _ref.route,
      badgeCount = _ref.badgeCount;
  return _react["default"].createElement(NavLinkWithRef, {
    className: classes.navItem,
    to: route,
    exact: route === '/',
    activeClassName: classes.active
  }, _react["default"].createElement("div", {
    className: classes.icon
  }, _react["default"].createElement(_Icon["default"], {
    icon: icon,
    color: "white"
  })), _react["default"].createElement(_Typography["default"], {
    type: "normal",
    style: {
      color: 'white'
    }
  }, label), badgeCount && _react["default"].createElement("div", {
    className: classes.badge
  }, _react["default"].createElement(_Badge["default"], {
    count: badgeCount
  })));
};

var _default = (0, _styles2.withStyles)(_styles.styles)(NavItem);

exports["default"] = _default;